import request from '@/utils/request'

// 分页查询联系人列表
export function listContact(data) {
  return request({
    url: '/crmContact/list',
    method: 'post',
    data: data
  })
}

// 查询联系人简要信息列表
export function contactListSimple(data) {
  return request({
    url: '/crmContact/listSimple',
    method: 'post',
    data: data
  })
}

// 按客户查询联系人列表
export function queryContactByCustomerId(query) {
  return request({
    url: '/crmContact/listByCustomerId',
    method: 'get',
    params: query
  })
}

// 查询联系人详情
export function queryContactDetail(query) {
  return request({
    url: '/crmContact/detail',
    method: 'get',
    params: query
  })
}

// 查询联系人
export function queryContactByMobileAndCustomer(query) {
  return request({
    url: '/crmContact/queryByMobileAndCustomer',
    method: 'get',
    params: query
  })
}

// 新增联系人
export function createContact(data) {
  return request({
    url: '/crmContact/create',
    method: 'post',
    data: data
  })
}

// 更新联系人
export function updateContact(data) {
  return request({
    url: '/crmContact/update',
    method: 'post',
    data: data
  })
}

// 查询联系人手机号
export function queryMobile(data) {
  return request({
    url: '/crmContact/queryMobile',
    method: 'post',
    data: data
  })
}

// 查询联系人任职履历 
export function queryResumeList(data) {
  return request({
    url: '/crmContactResume/list',
    method: 'post',
    data: data
  })
}

// 新增联系人任职履历 
export function addResume(data) {
  return request({
    url: '/crmContactResume/insert',
    method: 'post',
    data: data
  })
}

// 更新任职履历 
export function updateResume(data) {
  return request({
    url: '/crmContactResume/update',
    method: 'post',
    data: data
  })
}

// 删除任职履历 
export function deleteResume(query) {
  return request({
    url: `/crmContactResume/delete/${query.id}`,
    method: 'get',
  })
}

// 查询任职履历详情 
export function queryResumeDetail(query) {
  return request({
    url: `/crmContactResume/detail/${query.id}`,
    method: 'get',
  })
}